export default __webpack_public_path__ + "static/media/MCSW-blue.3cd282a9.png";